/* eslint-disable */
import React from 'react';
import { Modal } from 'react-bootstrap';
import commonLabels from '../labels/common_en.json';
// import { getTimeTableDetailsByAdvtId } from '../../timetablemanagement/actions/timetableManagementAction';
const ConfirmationDialog = (props) => {
    let IsConfirmation = props.IsConfirmation ? props.IsConfirmation : false;

    return (
        <Modal show={props.showModal} onHide={() => { props.setShowModal(false) }} backdrop='static'>
            <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
                <Modal.Title className='logout_title'>
                    {props.Title}
                </Modal.Title>
                  <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                    onClick={() => { props.setShowModal(false)}}
                    >X</button>
            </Modal.Header>
            <Modal.Body>
               {props.Message}
            </Modal.Body>
            <Modal.Footer>
                {IsConfirmation == "true" ? (
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-secondary" onClick={() => { props.setShowModal(false); }}>
                            {commonLabels.BUTTON_NO}
                        </button>
                        <button type="button" className=" btn btn-primary custom_button " onClick={() => { props.deleteRecord(props.deletedId); }}>
                            {commonLabels.BUTTON_YES}
                        </button>
                    </div>
                ) : (
                    <div>
                        <button type="button" className=" btn btn-primary custom_button " onClick={() => { props.setShowModal(false); }}>{commonLabels.BUTTON_OK}</button>
                    </div>
                )
                }
            </Modal.Footer>
        </Modal>
    )
}
export default ConfirmationDialog;